import React from 'react';
import { Button, Modal } from 'antd';
import WarnContent from '../WarnContent';
import styles from './index.less';

const LockedModal = (props) => {
  const { visible, handleClose } = props;
  return (
    <Modal
      width={443}
      centered
      visible={visible}
      maskClosable={false}
      footer={null}
      closable={false}
    >
      <WarnContent
        title="密码错误"
        text="当天密码连续10次错误，锁定不可查看，可联系超级管理员解除或者重置密码"
      />
      <div className={styles['locked-footer']}>
        <Button type="primary" onClick={handleClose}>确定</Button>
      </div>
    </Modal>
  );
};

export default LockedModal;
